import script from "./DownloadPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadPanel.vue?vue&type=style&index=0&id=4ecb0047&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecb0047"]])

export default __exports__